import { axios } from 'lib/axios';

export const subscribePushNotifications = (data) => {
  console.log(data);
  return axios.post('/users/subscribe', data);
};
